import { getReferentielDataFromServer } from "../components/general/AxiosReferencielInterceptor";

export function flattenArray(array, keysToExtract = []) {
    if(!Array.isArray(array) || !keysToExtract || keysToExtract.length === 0)
      return [];
    const result = [];
  
    array.forEach(item => {
      const extracted = {};
      keysToExtract.forEach(key => {
        if (key in item) {
          extracted[key] = item[key];
        }
      });
  
      if (Object.keys(extracted).length > 0) {
        result.push(extracted);
      }
  
      if (item.children && Array.isArray(item.children)) {
        result.push(...flattenArray(item.children, keysToExtract));
      }
    });
  
    return result;
  }


  export const downloadFile = async (guid) => {
    await getReferentielDataFromServer(
      false, 
      `/api/document/${guid}`, 
      {}, 
      "post",
      { responseType: "arraybuffer" }
    ).then((response) => {
      const blob = new Blob([response], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "document.pdf";
      link.click();
      window.URL.revokeObjectURL(url);
    }).catch((error) => console.error(error));
  }

  export const downloadFileV2 = async (guid, fileName = "document.pdf") => {
    try {
      const response = await getReferentielDataFromServer(
        false,
        `/api/document/${guid}`,
        {},
        "post",
        { responseType: "arraybuffer" }
      );
      const blob = new Blob([response], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      link.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
